<template>
    <div class="cntr">
        <input type="checkbox" id="cbx" class="hidden-xs-up">
        <label for="cbx" class="cbx"></label>
    </div>
</template>
<script>
export default {
    name: 'switchPoliticas',
    props: {
        color: {
            type: String,
            default: '#6871f1'
        }
    },
    mounted() {
        //Detectar el cambio del checkbox #cbx y si esta checkeado y ponerle un fondo   
        document.querySelector('#cbx').addEventListener('change', (e) => {
            if (e.target.checked) {
                document.querySelector('.cbx').style.background = this.color
            } else {
                document.querySelector('.cbx').style.background = '#fff'
            }
        }) 
    },
}
</script>
<style>
.cbx {
    position: relative;
    top: 1px;
    width: 20px;
    height: 20px;
    border: 1px solid #c8ccd4;
    border-radius: 3px;
    vertical-align: middle;
    transition: background 0.1s ease;
    cursor: pointer;
    display: block;
}

.cbx:after {
    content: '';
    position: absolute;
    top: 2px;
    left: 6px;
    width: 6px;
    height: 12px;
    opacity: 0;
    transform: rotate(45deg) scale(0);
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transition: all 0.3s ease;
    transition-delay: 0.15s;
}

.lbl {
    margin-left: 5px;
    vertical-align: middle;
    cursor: pointer;
}

#cbx:checked~.cbx {
    background: #6871f1;
}

#cbx:checked~.cbx:after {
    opacity: 1;
    transform: rotate(45deg) scale(1);
}

.cntr {
    position: relative;
}

@keyframes jelly {
    from {
        transform: scale(1, 1);
    }

    30% {
        transform: scale(1.25, 0.75);
    }

    40% {
        transform: scale(0.75, 1.25);
    }

    50% {
        transform: scale(1.15, 0.85);
    }

    65% {
        transform: scale(0.95, 1.05);
    }

    75% {
        transform: scale(1.05, 0.95);
    }

    to {
        transform: scale(1, 1);
    }
}

.hidden-xs-up {
    display: none !important;
}
</style>